import {
  DEFAULT_PHONE_COUNTRY,
  type PhoneCountryCode,
} from "@project/lib/mobile-number";

export type DonorInfo = {
  name: string;
  mobile: string;
  mobile_country: PhoneCountryCode;
  alt_mobile: string;
  alt_mobile_country: PhoneCountryCode;
  email: string;
  pan: string;
  aadhaar: string;
  date_of_birth: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  country: string;
  csr_eligibility: boolean;
  occupation: string;
  company: string;
  family_name: string;
};

export const emptyDonor: DonorInfo = {
  name: "",
  mobile: "",
  mobile_country: DEFAULT_PHONE_COUNTRY,
  alt_mobile: "",
  alt_mobile_country: DEFAULT_PHONE_COUNTRY,
  email: "",
  pan: "",
  aadhaar: "",
  date_of_birth: "",
  address: "",
  city: "",
  state: "",
  pincode: "",
  country: "India",
  csr_eligibility: false,
  occupation: "",
  company: "",
  family_name: "",
};

export type PaymentInfo = {
  payment_mode: string;
  transaction_id: string;
  cheque_no: string;
  bank_name: string;
};

export const emptyPayment: PaymentInfo = {
  payment_mode: "",
  transaction_id: "",
  cheque_no: "",
  bank_name: "",
};
